module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"profit":"Profit increase","profitLabel":"Contribution to margin","timeLabel":"Average diner time decrease","loading":"Loading..."},"es":{"profit":"Incremento porcentual de la rentabilidad","profitLabel":"Contribución al margen","timeLabel":"Disminución de tiempo medio","loading":"Cargando..."}}')
  delete Component.options._Ctor
}
